<template>
  <div class="periodicFunctionality">
    <period-date-picker @getDate="getFunctionality" class=""/>
    <div class="py-2">
      <PeriodWork :periodWork="periodWork" />
    </div>
  </div>
</template>

<script>
import PeriodWork from "../../components/functionality/period/PeriodWork.vue";
import EosToastType from '../../model/EosToastType';
export default {
  components: {
    PeriodWork,
  },
  
  data() {
    return {
      periodWork: {},
    };
  },
  methods: {
    
    getFunctionality(year, month) {
      if (year == {} || month == "") {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("msg-empty-date-err"),
        });
        
        return;
      }

      const params = new URLSearchParams();
      params.append("period", month);
      params.append("year", year);

      localStorage.setItem("selectedperiod",month);
      localStorage.setItem("selectedYear",year);

      this.$store
        .dispatch("GetPersonPeriodWork", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            var data = [];
            data = result.data;
            if (data.length > 0) {
              this.periodWork = data[0];
              this.periodWork.year = year
              this.periodWork.period = month
              this.periodWork.isPeriod = true;
            }
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
              type: EosToastType.error,
              msg: `${error}`,
            });
        });
    },
  },
};
</script>

<style scoped>
.v-text-field__details {
  display: none;
}
</style>